import { Button, Table, Popconfirm, message } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { apiUrl } from '../../config'
import ColorModal from '../ModalComponent/ConstraintModal/ColorModal'

const Color = () => {
    const { t } = useTranslation();

    const [allData, setAllData] = useState([])
    const [modifiedData, setModifiedData] = useState([])
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedRow, setSelectedRow] = useState([])
    const [refreshPage, setRefreshPage] = useState(false)
    const [rule, setRule] = useState("")
    const username = process.env.REACT_APP_USERNAME;
    const password = process.env.REACT_APP_SECRET_KEY;
    const getData = () => {
        axios.get(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/getColor/all`, {
            auth: {
                username: username,
                password: password
            }
        })
            .then(res => setAllData(res.data))
            .catch(err => console.log(err))
    }

    useEffect(() => {
        getData()
    }, [refreshPage])

    const handleClick = (row) => {
        setSelectedRow(row)
        setModalOpen(true)
        setRule("changeOrder")
    }
    useEffect(() => {
        const dataList = allData?.map((item, index) => ({
            key: index + 1,
            description: item?.description,
            front_body_balanced: item?.front_body_balanced,
            id: item?.id
        }));

        setModifiedData([...dataList]);
    }, [allData]);

    const handleDelete = (row) => {
        axios.delete(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/deleteColor/${row.id}`, {
            headers: {
                Authorization: `Basic ${btoa(`${username}:${password}`)}`
            }
        })
            .then(res => {
                setRefreshPage(!refreshPage);
            })
            .catch(err => {
                console.error("Silme işlemi sırasında hata oluştu:", err);
            });
    };


    const columns = [
        {
            title: t("constraints.color"),
            dataIndex: "description",
            key: "description",
            align: "center",
            width: 120,
        },
        {
            title: t("constraints.frontBodyBalanced"),
            dataIndex: "front_body_balanced",
            key: "front_body_balanced",
            width: 90,
            align: "center",
            render: (text, record) => (
                <span>{record.front_body_balanced ? t("constraints.yes") : t("constraints.no")}</span>
            ),

        },
        {
            title: t("constraints.process"),
            dataIndex: "islem",
            key: "islem",
            align: "center",
            width: 220,
            render: (record, row) => {
                return (
                    <div className='flex flex-row gap-3 justify-center'>
                        <Button
                            onClick={() => handleClick(row)}
                            style={{ fontFamily: "sans-serif" }}
                            className='text-white bg-smartopt font-semibold'
                        >
                            {t("constraints.change")}
                        </Button>
                        <Popconfirm
                            title={t("constraints.delete")}
                            description={t("constraints.confirmDelete")}
                            onConfirm={() => {
                                handleDelete(row)
                                message.success(t("constraints.updateSuccess"));
                            }}
                            onCancel={() => console.log("cancel")}
                            okText={t("constraints.yes")}
                            cancelText={t("constraints.no")}
                            okType="primary"
                        >
                            <Button
                                style={{ fontFamily: "sans-serif" }}
                                className='text-white bg-smartopt font-semibold'
                            >
                                {t("constraints.delete")}
                            </Button>
                        </Popconfirm>
                    </div>
                );
            },
        },



    ];


    return (
        <div style={{ maxHeight: '82vh', overflowY: 'auto' }}>
            <ColorModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                modifiedData={modifiedData}
                selectedRow={selectedRow}
                rule={rule}
                setRefreshPage={setRefreshPage}
                refreshPage={refreshPage}
            />
            <div className="flex p-4 flex-col h-full gap-2 ">
                <div className='flex w-max bg-smartopt rounded-lg'>
                    <Button className='text-white font-semibold' onClick={() => {
                        setModalOpen(true)
                        setRule("newOrder")
                    }}>
                        {t("constraints.addColor")}
                    </Button>
                </div>
                <div className="tableAsma flex h-full overflow-auto w-full">
                    <Table
                        bordered
                        sticky
                        dataSource={modifiedData}
                        columns={columns}
                        scroll={{ x: 700 }}
                        pagination={{ pageSize: 6 }}
                    />
                </div>
            </div>
        </div>
    )
}

export default Color
